"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CompanyUserInfoModal = require("../modal/CompanyUserInfoModal");

var _CompanyUserInfoModal2 = _interopRequireDefault(_CompanyUserInfoModal);

var _PrivateUserInfoModal = require("../modal/PrivateUserInfoModal");

var _PrivateUserInfoModal2 = _interopRequireDefault(_PrivateUserInfoModal);

var _Input = require("../form/Input");

var _Input2 = _interopRequireDefault(_Input);

var _Checkbox = require("../form/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _SubmitButton = require("../form/SubmitButton");

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

var _RadioGroup = require("../form/RadioGroup");

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LicenseRegistrationForm = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LicenseRegistrationForm, _Component);

  function LicenseRegistrationForm() {
    (0, _classCallCheck3.default)(this, LicenseRegistrationForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LicenseRegistrationForm.__proto__ || (0, _getPrototypeOf2.default)(LicenseRegistrationForm)).call(this));

    _this.onSubmit = function (values) {
      values.send_transfer_requests = values.send_transfer_requests || false;
      if (_this.props.emailInUse) {
        _this.props.login(values);
      } else {
        _this.props.register(values);
      }
    };

    _this.state = {
      showProUserInfoModal: false,
      showFreeUserInfoModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(LicenseRegistrationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props$fields = this.props.fields,
          email = _props$fields.email,
          first_name = _props$fields.first_name,
          last_name = _props$fields.last_name,
          phone = _props$fields.phone;

      email.onChange(this.props.invitation.receiver_email);
      phone.onChange(this.props.invitation.receiver_phone);
      var firstName = this.props.invitation.receiver_name.replace(/ .*/, "");
      var lastName = this.props.invitation.receiver_name.split(" ").pop();;

      first_name.onChange(firstName);
      last_name.onChange(lastName);
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          !this.props.emailInUse && _react2.default.createElement(
            "h1",
            { className: "h4" },
            "REKISTER\xD6IDY PALVELUUMME"
          ),
          !this.props.emailInUse && _react2.default.createElement(
            "p",
            null,
            "Ota kuljettajalisenssi k\xE4ytt\xF6\xF6n t\xE4ytt\xE4m\xE4ll\xE4 alla olevat kohdat"
          ),
          this.props.emailInUse && _react2.default.createElement(
            "h1",
            { className: "h4" },
            "Ota lisenssi k\xE4ytt\xF6\xF6n"
          ),
          this.props.emailInUse && _react2.default.createElement(
            "p",
            null,
            "Saamasi linkin s\xE4hk\xF6postiosoite on k\xE4yt\xF6ss\xE4. Voit ottaa kuljettajalisenssin k\xE4ytt\xF6\xF6n antamalla salasanan."
          )
        ),
        this.renderLicenseRegistrationForm()
      );
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var registrationError = this.props.auth.registrationError;

      if (registrationError) {
        var text = void 0;
        if (registrationError === "EMAIL_IN_USE") {
          this.props.setEmailInUse(true);
          text = "Sähköpostiosoite on jo käytössä.";
        } else if (registrationError === "TOS_NOT_ACCEPTED") {
          text = "Sinun on hyväksyttävä käyttöehdot ja rekisteriseloste.";
        } else {
          text = "Valitettavasti rekisteröinti ei onnistunut. Yritä myöhemmin uudelleen.";
        }
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            { className: "error-message error-message-js" },
            text
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/kirjaudu" },
            "Kirjaudu"
          )
        );
      }
    }
  }, {
    key: "renderLicenseRegistrationForm",
    value: function renderLicenseRegistrationForm() {
      var _props = this.props,
          auth = _props.auth,
          profile = _props.fields.profile;


      return _react2.default.createElement(
        "form",
        { id: "register", className: "col col-xs-12", onSubmit: this.props.handleSubmit(this.onSubmit) },
        this.renderRegistrationFields(),
        this.renderAcceptTos(),
        this.renderError(),
        this.renderSubmit()
      );
    }
  }, {
    key: "renderRegistrationFields",
    value: function renderRegistrationFields() {
      var _props$fields2 = this.props.fields,
          email = _props$fields2.email,
          first_name = _props$fields2.first_name,
          last_name = _props$fields2.last_name,
          phone = _props$fields2.phone,
          password = _props$fields2.password,
          password2 = _props$fields2.password2;
      var _props2 = this.props,
          auth = _props2.auth,
          profile = _props2.fields.profile;


      if (profile.value === "") {
        return null;
      }

      return _react2.default.createElement(
        "div",
        null,
        this.props.emailInUse && _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          "Kirjaudu"
        ),
        !this.props.emailInUse && _react2.default.createElement(
          "h2",
          { className: "h4 form-title form-title-js" },
          "Yhteystiedot"
        ),
        this.props.emailInUse && _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email }),
            "            "
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Input2.default,
              { id: "password", type: "password", label: "Salasana", fieldProps: password },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "Salasanan tulee olla 8 merkki\xE4 pitk\xE4."
              )
            ),
            "            "
          )
        ),
        !this.props.emailInUse && _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "first_name", type: "text", label: "Etunimi", fieldProps: first_name })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "last_name", type: "text", label: "Sukunimi", fieldProps: last_name })
          )
        ),
        !this.props.emailInUse && _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "email", type: "email", label: "S\xE4hk\xF6posti", fieldProps: email })
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "phone", type: "text", label: "Puhelinnumero", fieldProps: phone })
          )
        ),
        !this.props.emailInUse && _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Input2.default,
              { id: "password", type: "password", label: "Salasana", fieldProps: password },
              _react2.default.createElement(
                "p",
                { className: "small" },
                "Salasanan tulee olla 8 merkki\xE4 pitk\xE4."
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(_Input2.default, { id: "password2", type: "password", label: "Salasana uudelleen", fieldProps: password2 })
          )
        )
      );
    }
  }, {
    key: "renderAcceptTos",
    value: function renderAcceptTos() {
      var tos_accepted = this.props.fields.tos_accepted;
      var profile = this.props.fields.profile;


      if (profile.value && !this.props.emailInUse) {
        return _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-sm-6" },
            _react2.default.createElement(
              _Checkbox2.default,
              { id: "tos_accepted", label: "Hyv\xE4ksyn k\xE4ytt\xF6ehdot ja rekisteriselosteen", fieldProps: tos_accepted },
              _react2.default.createElement(
                "p",
                { className: "small" },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: "/kayttoehdot", target: "_blank", rel: "noopener noreferrer" },
                  "Lue k\xE4ytt\xF6ehdot ja rekisteriseloste"
                )
              )
            )
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: "renderUserHelpText",
    value: function renderUserHelpText() {
      var profile = this.props.fields.profile;


      return _react2.default.createElement(
        "div",
        null,
        "User help text"
      );
    }
  }, {
    key: "renderSubmit",
    value: function renderSubmit() {
      var _props3 = this.props,
          auth = _props3.auth,
          profile = _props3.fields.profile;

      if (profile.value === "") {
        return null;
      }

      var submitText = "Luo lisenssi";

      if (this.props.emailInUse) {
        submitText = "Kirjaudu";
      }

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { className: "row" },
          _react2.default.createElement(
            "div",
            { className: "col col-xs-12" },
            _react2.default.createElement(_SubmitButton2.default, { text: submitText, submitting: auth.registrationLoading || false })
          )
        )
      );
    }
  }]);
  return LicenseRegistrationForm;
}(_react.Component), _class.propTypes = {
  handleSubmit: _react.PropTypes.func.isRequired,
  login: _react.PropTypes.func.isRequired,
  register: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  invitationToken: _react.PropTypes.string,
  setEmailInUse: _react.PropTypes.func,
  emailInUse: _react.PropTypes.bool
}, _temp);
exports.default = LicenseRegistrationForm;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/registration/LicenseRegistrationForm.js
 ** module id = 1184
 ** module chunks = 0
 **/